import { Link, usePage } from '@inertiajs/react';
import clsx from 'clsx'
import { useState } from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { UploadProgressProvider, useUploadProgress } from './Scripts/UploadProgressContext.jsx';


import { Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react'
import {
  Bars3Icon,
  CircleStackIcon,
  CubeIcon,
  HomeIcon,
  XMarkIcon,
  ClipboardDocumentCheckIcon,
  BeakerIcon,
  BanknotesIcon,
  MinusCircleIcon,
  CreditCardIcon,
  PlusCircleIcon,
  ArrowDownCircleIcon,
  ArrowRightCircleIcon, 
  UserCircleIcon, 
  CheckCircleIcon
} from '@heroicons/react/24/outline'
import Spinner from './Components/spinner.jsx';
import { ArrowUpCircleIcon } from '@heroicons/react/20/solid';


const navigation = [
  // { name: 'Dashboard', href: '/dashboard', icon: HomeIcon, current: url === '/dashboard' },
  // { name: 'Projects', href: '/projects', icon: BeakerIcon, current: url === '/projects' },
 
  { name: 'Models', href: '/models', icon: CubeIcon },
  { name: 'Dicom Store', href: '/dicomstore', icon: CircleStackIcon },
  { name: 'Tasks', href: '/tasks', icon: ClipboardDocumentCheckIcon },
  { name: 'Credits', href: '/billing', icon: BanknotesIcon },

  { name: 'Account Requests', href: '/admin/accounts/activation', icon: UserCircleIcon, admin: true },
  { name: 'Model Requests', href: '/admin/requests', icon: ArrowRightCircleIcon, admin: true },
  { name: 'System Status', href: '/admin/status', icon: CheckCircleIcon, admin: true },
  { name: 'AWS Cost Reports', href: '/admin/cost', icon: CreditCardIcon, admin: true },
]


/* deprecated, old light design, now we use the dark Side from home.page.jsx. */
/* when introducing a light mode, we may come back to this so we keep it for now */
export function Site({ showHeader = true, children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="fixed inset-0 -z-10 h-full w-full bg-white">
        <div className="absolute left-0 right-0 top-0 -z-10 m-auto h-[310px] w-[310px] rounded-full bg-fuchsia-400 opacity-20 blur-[100px]"></div>
      </div>
      { showHeader && <Header sticky={true} /> }
      <div className="flex flex-1 flex-col mx-auto h-full w-full px-4 md:px-6 lgx:px-8 max-w-5xl">
        <main className="px-4 flex-gro">
          { children }
        </main>
        <footer className="mt-auto text-center py-4">
          <p className="text-sm text-[#7b8f98]">
            &copy; 2025 Leonard N&uuml;rnberg. All rights reserved.
          </p>
          <p>
            <Link href="/legal/agb" className="text-sm text-purple-400">Terms of Use</Link>
            <span className="mx-2">•</span>
            <Link href="/legal/privacy" className="text-sm text-purple-400">Privacy Policy</Link>
          </p>
        </footer>
      </div>
      {/* <svg className="absolute bottom-0" viewBox="0 0 1425 205.55" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path d="M0,17.27l23.75,5.09C47.5,27.38,95,37.57,142.5,39.47s95-4.36,142.5-10.28,95-11.35,142.5-7.4,95,17.43,142.5,24,95,6.25,142.5,5.83,95-.9,142.5-3S950,43,997.5,42.92s95,3.12,142.5,2.88,95-4.11,142.5-3.62,95,5.51,118.75,8L1425,52.62v170.2H0Z" fill="#7b8f98"></path>
          <path d="M0,94.56l23.75-6.17C47.5,82.22,95,69.89,142.5,65.2s95-1.64,142.5,4.85S380,86.33,427.5,86.5,522.5,77,570,73.59s95-.66,142.5,1.81,95,4.6,142.5,3.78,95-4.6,142.5-6.58,95-1.89,142.5,1.24,95,9.45,142.5,13.15,95,4.85,118.75,5.35l23.75.57V222.82H0Z" fill="#3b5f71"></path>
          <path d="M0,134,23.75,132C47.5,129.91,95,125.8,142.5,125.39s95,2.88,142.5,5.75,95,5.35,142.5,4,95-6.58,142.5-8.06,95,.66,142.5-.41,95-5.51,142.5-9.21,95-6.66,142.5-5.83,95,5.42,142.5,9.86,95,8.47,142.5,9.05,95-2.47,118.75-4L1425,125v97.84H0Z" fill="#5a7a8a"></path>
          <path d="M0,178.42l23.75-1.64c23.75-1.65,71.25-4.94,118.75-5.59s95,1.23,142.5,2.71,95,2.63,142.5,4.11,95,3.45,142.5,2.88,95-3.54,142.5-8.8,95-12.58,142.5-13.57,95,4.53,142.5,8.23,95,5.67,142.5,4,95-6.91,142.5-9.79,95-3.37,118.75-3.7L1425,157v65.78H0Z" fill="#2d3e47"></path>
        </g>
        <defs>
          <clipPath id="clip0"><rect width="1425" height="444" fill="white"></rect></clipPath>
        </defs>
      </svg> */}
    </div>
  )
}

/* Displays platform processing status, upload progress and task queue information */
function ProcessingInformation() {
  const { props: { features, auth } } = usePage();

  const credits = auth.user?.credits;
  const queue = auth.user?.queue || { num_running: 0, num_created: 0, num_waiting: 0, num_reserved: 0, num_ready_to_dl: 0 };

  const { progress } = useUploadProgress();

  const prog_num = Object.keys(progress).length;
  const prog_val = Object.values(progress).reduce((acc, val) => acc + val, 0) / prog_num;

  return (
    <div className="
      flex flex-col gap-3 
      bg-slate-700 px-4 rounded-md py-5 mt-2
      lg:bg-slate-700/50 lg:border-none lg:px-4 lg:pt-5 lg:pb-5 lg:rounded-md lg:-mx-2 lg:my-3
    ">

      { /* border-less: lg:pb-10 lg:border-slate-700 lg:px-2 lg:pt-0 lg:border-b lg:-mx-2 lg:mt-4 lg:mb-3 lg:bg-transparent lg:rounded-none */ }
              
      { /* Credits and billing information */ }
      <Link href="/billing">
        <div
          className="flex items-center gap-x-2 relative group cursor-pointer transition-colors duration-200 hover:bg-slate-600/50 rounded -m-1 p-1"
          tabIndex={0}
        >
          <span className="relative flex items-center">
            <CreditCardIcon className={clsx("size-6 group-hover:hidden", credits ? 'text-green-400' : 'text-red-400')} aria-hidden="true" />
            <PlusCircleIcon className="size-6 text-green-400 hidden group-hover:inline" aria-hidden="true" />
          </span>
          <p className="text-md text-slate-300 transition-colors duration-200">
              <span className="group-hover:hidden">
                You have <span className="text-slate-100">{credits || "no"}</span> credits.
              </span>
              <span className="hidden group-hover:inline text-slate-100">
                Add credits
              </span>
          </p>
        </div>
      </Link>

      {/* Upload progress bar */}
      { prog_num > 0 && <>
        <div className="flex items-center gap-x-2 cursor-pointer transition-colors duration-200 hover:bg-slate-500 rounded -m-1 p-1">
          <ArrowUpCircleIcon className="size-6 text-blue-400" />
          <span className="text-md text-slate-300">
            {prog_num} uploads in progress
          </span>
        </div>
        <div className="flex flex-col">
          <div className="relative h-2 bg-slate-600 rounded-sm overflow-hidden">
            <div className="absolute left-0 top-0 h-full bg-blue-400" style={{ width: `${prog_val}%` }}></div>
          </div>   
        </div>
      </> }

      { /* Platform processing status and task queue information */ }
      <div className="flex items-center gap-x-2 cursor-default text-yellow-400">
        {
          queue.num_running > 0 ?
          <Spinner className="size-6" /> :
          <BeakerIcon className="size-6 " aria-hidden="true" />
        }
        <p className="text-md text-slate-300">
          { queue.num_running > 0 ?
            `Your have ${queue.num_running} running tasks.` :   
            (queue.num_created + queue.num_waiting) > 0 ?
            `You have ${queue.num_created + queue.num_waiting} tasks.` :
            "You have no tasks."
          }
        </p>
      </div>

      { /* Task queue progress bar */ }
      {features?.task_processing && (
        <div className="flex flex-col">
          <div className="relative h-2 bg-yellow-300 rounded-sm overflow-hidden">
          <div className="absolute left-0 top-0 h-full bg-slate-500" style={{ width: `${queue.num_reserved / (queue.num_reserved + queue.num_waiting + 0.0001) * 100}%` }}></div>
          </div>
          <p className="flex justify-between text-md text-slate-300 w-full">
          <span 
            title="Number of other tasks in the queue before your tasks are started"
            className="text-slate-900 px-2 rounded-sm bg-slate-500 pin-up-left-2 cursor-default"
          >
            {queue.num_reserved} queued
          </span>
          <span 
            title="Number of your tasks that are waiting to be processed"
            className="text-slate-800 px-2 rounded-sm bg-yellow-300 pin-up-right-2 hover:bg-yellow-400 cursor-pointer transition duration-200"
          >
            <Link href="/tasks" className="text-slate-900 hover:text-slate-800">
            {queue.num_waiting} waiting
            </Link>
          </span>
          </p>           
        </div>
      )}

      {/* Platform processing status indicator */}
      {!features?.task_processing && (
        <div className="flex items-center gap-x-2 bg-red-400 text-gray-700 py-1 px-2 rounded-md">
          <MinusCircleIcon className="w-12" aria-hidden="true" />
          <span>
          Platform processing is currently <b>disabled</b>.
          </span>
        </div>
      )}

      {/* Ready for download information */}
      {queue.num_ready_to_dl > 0 && (
        <Link href="/tasks" className="flex items-center gap-x-2 cursor-pointer transition-colors duration-200 hover:bg-slate-500 rounded -m-1 p-1">
          <ArrowDownCircleIcon className="size-6 text-green-400" />
          <span className="text-md text-slate-300">
            {queue.num_ready_to_dl} ready for download.
          </span>
        </Link>
      )}
    </div>
  );
}

function NavigationItem({ item }) {
  const { url, props: { auth } } = usePage();

  const isAdmin = auth.user?.isAdmin;
  const isCurrent = url === item.href;

  return (
    (item.admin && !isAdmin) ? null :
    <li key={item.name}>
      <Link
        href={item.href}
        className={clsx(
          isCurrent
            ? 'bg-slate-700/50 text-white'
            : 'text-gray-400 hover:bg-slate-700/30 hover:text-white',
          'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
        )}
      >
        <item.icon aria-hidden="true" className="size-6 shrink-0" />
        {item.name}
      </Link>
    </li>
  )
}

function AccountActivationStatus() {
  const { props: { auth } } = usePage();

  const activation = auth.user?.activation;

  if (!activation) {
    return null;
  }

  if (activation.is_activated) {
    return null;
  }

  if (activation.state == 'requested') {
    return (
      <div className="bg-yellow-100 border-l-4 border-yellow-400 text-yellow-700 p-4 rounded-md">
        <p>
          Your activation request is being reviewed.<br/>
          <Link href="/account/activate" className="text-yellow-700 underline">
            Check status
          </Link>
          .
        </p>
      </div>
    )
  }

 if (activation.state != 'requested') {
    return (
      <div className="bg-red-100 border-l-4 border-red-400 text-red-700 p-4 rounded-md">
        <p>
          Your account is not activated.
          <br/>
          <Link href="/account/activate" className="text-red-700 underline">
            Request account activation
          </Link>
        </p>
      </div>
    )
  }
}

function MobileNavigation() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { url, props: { auth } } = usePage();

  return (
    <div className="lg:hidden">
      <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-slate-800/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
        />

        <div className="fixed inset-0 flex">
          <DialogPanel
            transition
            className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
          >

            <TransitionChild>
              <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                <button type="button" onClick={() => setSidebarOpen(false)} className="-m-2.5 p-2.5">
                  <span className="sr-only">Close sidebar</span>
                  <XMarkIcon aria-hidden="true" className="size-6 text-white" />
                </button>
              </div>
            </TransitionChild>

            <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-slate-800 px-6 pb-2 ring-1 ring-white/10">

              { /* Logo */ }
              <div className="flex h-16 mx-auto shrink-0 items-center">
                <img
                  alt="MHub Cloud Logo"
                  src="/images/mcloud_logo.png"
                  className="h-12 w-auto mt-5 -ml-1"
                />
              </div>

              { /* platform status indicator and progress bar */}
              <ProcessingInformation />
              
              { /* Account activation status */ }
              <AccountActivationStatus />

              {/* Navigation Items */}
              <nav className="">
                <ul role="list" className="-mx-2 space-y-1">
                  {navigation.map((item) => <NavigationItem key={item.name} item={item} />)}
                </ul>
              </nav>

            </div>
          </DialogPanel>
        </div>
      </Dialog>

      { /* Mobile top navigation bar */ }
      <div className="sticky top-0 z-40 flex items-center gap-x-6 bg-slate-800 px-4 py-4 shadow-sm sm:px-6">
          
          <button type="button" onClick={() => setSidebarOpen(true)} className="-m-2.5 p-2.5 text-gray-400">
            <span className="sr-only">Open sidebar</span>
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>

          <div className="flex-1 text-sm/6 font-semibold text-white">
            { navigation.find(n => n.href === url)?.name || "Dashboard" }
          </div>

          <Link
            href="/auth/logout"
            method="post"
            className="flex items-center gap-x-4 px-6 py-3 text-sm/6 font-semibold text-white hover:bg-gray-800"
          >
            <span className="sr-only">Your profile</span>
            { auth.user?.avatar ? 
              <img
                alt=""
                src={auth.user.avatar}
                className="size-8 rounded-full bg-gray-800"
              /> :
              <img
                alt=""
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                className="size-8 rounded-full bg-gray-800"
              />
            }
          </Link>
        </div>
    </div>
  )
}

function DesktopNavigation() {
  const { props: { auth } } = usePage();

  return (
    <div className="hidden lg:flex fixed inset-y-0 z-50 w-80 flex-col">

      {/* Sidebar component, swap this element with another sidebar if you like */}
      <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-slate-800 px-6 m-5 rounded-xl shadow-2xl">
        
        { /* Logo */ }
        <div className="flex h-16 shrink-0 items-center mx-auto mt-4">
          <Link href="/">
            <img
              alt="MHub Cloud Logo"
              src="/images/mcloud_logo.png"
              className="h-12 w-auto mt-5 -ml-1"
            />
          </Link>
        </div>

        {/* platform status indicator and progress bar */}
        <ProcessingInformation />

        {/* Navigation */}
        <nav className="flex flex-1 flex-col">
            <ul role="list" className="-mx-2 space-y-1">
              {navigation.map((item) => <NavigationItem key={item.name} item={item} />)}
            </ul>
        </nav>

        { /* Account activation status */ }
        <AccountActivationStatus />

        { /* User profile and logout button */ }
        <Link
            href="/auth/logout"
            method="post"
            className="flex items-center w-full gap-x-4 py-3 text-sm/6 font-semibold text-white hover:bg-gray-800"
          >
            { auth.user?.avatar ? 
              <img
                alt=""
                src={auth.user.avatar}
                className="size-8 rounded-full bg-gray-800"
              /> :
              <img
                alt=""
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                className="size-8 rounded-full bg-gray-800"
              />
            }
            <span className="sr-only">Your profile</span>
            <span aria-hidden="true">{ auth.user.name }</span>
        </Link>
            
      </div>
    </div>
  )
}


/* Main application layout with sidebar and header */
export default function App({ children }) {

  return (
    <UploadProgressProvider>
      <div>

        { /* Sidebar navigation for desktop */ }
        <MobileNavigation />
        <DesktopNavigation />        

        { /* Main content area */ }
        <main className="py-10 lg:pl-72">
          <div className="px-4 sm:px-6 lg:px-8">{ children }</div>
        </main>

      </div>
    </UploadProgressProvider>
  )  
}